import { createFileRoute, redirect } from '@tanstack/react-router'
import SignIn from '../components/Auth/SignIn'
import { AuthStates } from 'blick.react.utils'

export const Route = createFileRoute('/sign-in')({
    component: SignIn,
    beforeLoad: ({ context }) => {
        if (context.auth.status === AuthStates.Authenticated) {
            throw redirect({
                to: '/',
            })
        }
    },
})